import request from "../../request";
import { getKategori } from "../../firebaseReshaper";

const getStrkWithId = (id, str) => {
  let strTmp = {};
  str.map(str1 => {
    if (str1.id === id) {
      strTmp = str1;
    }
    return true;
  });
  return strTmp;
};

export const getAllStrukturat = async () => {
  let response = await request({}, "/api/struktura/GetAllStrukturat", "index");

  return response;
};

export const getStrukturaById = async id => {
  let response = await request(
    {},
    "/api/struktura/GetStrukturaDetailsByID/" + id,
    "index"
  );

  return response;
};
export const getStrukturaMeKategori = async () => {
  let struktura = await getAllStrukturat();
  let strKategori = await getKategori();
  let reshaped = strKategori.map(kat => {
    kat.struktura = kat.struktura.map(str => {
      return getStrkWithId(str.id ? str.id : str, struktura);
    });
    return kat;
  });
  return reshaped;
};
